import PropTypes from "prop-types"
import { autoFormatter } from "helpers/formatters/numbers"
import { formatValueOrDash } from "helpers/assets/tooltips"

export default function PositionRow({ label, percentEquity, economicExposure, showSize }) {
  return (
    <div className="position-row">
      <span>{label}</span>
      <span className="value">
        <span>{formatValueOrDash(percentEquity)}</span>
      </span>
      {showSize && (
        <span className="value">
          {economicExposure ? autoFormatter(economicExposure) : "-"}
        </span>
      )}
    </div>
  )
}

PositionRow.propTypes = {
  label: PropTypes.string.isRequired,
  percentEquity: PropTypes.number.isRequired,
  economicExposure: PropTypes.number,
  showSize: PropTypes.bool,
}
